export function sortPersonalFirst<T extends { id: string }>(
  spaces: readonly T[],
  personalSpaceId: string | null
): T[] {
  return [...spaces].sort((a, b) => {
    if (a.id === personalSpaceId) return -1;
    if (b.id === personalSpaceId) return 1;
    return 0;
  });
}
